import { TEST, ADMIN } from "../../../data/page_types"

export default () => window.location.pathname.toLowerCase().includes(`/${ADMIN}`)
  || window.location.host === `${ADMIN}.ulsemo.com`
  || window.location.host === `${ADMIN}.ulsemo.localhost:8081`
  || window.location.host.split(".")[0] === `${TEST}-${ADMIN}`
